import { AuthService } from './../../services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { filter, merge, takeUntil } from 'rxjs/operators';
import { CheckoutStatusModel, CheckoutViewModel } from '../../models/check-out.model';
import { ICheckoutMenu } from '../../models/imenu.model';
import { CheckOutService } from '../../services/checkout.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
    selector: 'app-renewal-checkout',
    templateUrl: './renewals-checkout.component.html',
    styleUrls: ['./renewals-checkout.component.css']
})
export class RenewalsCheckoutComponent implements OnInit, OnDestroy {

    checkoutInitiated = false;

    checkoutMenu: ICheckoutMenu[] = [
        {
            menuName: 'Delivery Location',
            stepName: 'ADDRESS',
            id: 'addressStep',
            selected: false
        },
        {
            menuName: 'End User Information',
            stepName: 'ENDUSER',
            id: 'endUserStep',
            selected: false
        },
        {
            menuName: 'Tenant Information',
            stepName: 'TENANT',
            id: 'tenantStep',
            selected: false
        },
        {
            menuName: 'Freight & Shipping Method',
            stepName: 'FREIGHT',
            id: 'freightStep',
            selected: false
        },
        {
            menuName: 'Donation',
            stepName: 'DONATION',
            id: 'donationStep',
            selected: false
        },
        {
            menuName: 'Payment',
            stepName: 'PAYMENT',
            id: 'paymentStep',
            selected: false
        },
        {
            menuName: 'Summary & Order',
            stepName: 'SUMMARY',
            id: 'summaryStep',
            selected: false
        }
    ];

    serial: string;

    defaultFirstStep = '';

    currentCheckoutStep = '';

    tenantDetailsRequired = '';

    checkoutMenuFilter: ICheckoutMenu[] = [];

    checkoutViewModel: CheckoutViewModel;

    urlSegments: string[];

    lastChild: string;

    currentUserModel: CurrentUserModel;

    ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private checkoutService: CheckOutService,
        private authService: AuthService

    ) {

    }

    redirectTo(stepName: string) {
        let newChildSegment = '';

        switch (stepName) {
            case 'ADDRESS': {
                newChildSegment = 'ship-address';
                break;
            }
            case 'ENDUSER': {
                newChildSegment = 'end-user';
                break;
            }
            case 'TENANT': {
                newChildSegment = 'tenant';
                break;
            }
            case 'FREIGHT': {
                newChildSegment = 'freight-ship';
                break;
            }
            case 'PAYMENT': {
                newChildSegment = 'payment-method';
                break;
            }
            case 'DONATION': {
                newChildSegment = 'donation';
                break;
            }
            case 'SUMMARY': {
                newChildSegment = 'summary-order';
                break;
            }

        }
        this.router.navigate([newChildSegment], { relativeTo: this.route });
        // const urlSegments = this.router.url.split('/');
        // const lastChild = urlSegments[urlSegments.length - 1];
        // const newUrl = this.router.url.toString().replace(lastChild, newChildSegment);
        // this.router.navigate([newUrl]);
    }

    ngOnInit() {

        // this.checkoutService.currentCheckoutStatusModel.takeUntil(this.ngUnsubscribe).subscribe(res => {
        //     this.currentCheckoutStep = res.currentStep;
        //     console.log(`this.currentCheckoutStep`, this.currentCheckoutStep);
        // });
        this.authService.getLoginInfo().subscribe((value: CurrentUserModel) => {
            this.currentUserModel = value;
        });

        this.checkoutService.currentCheckoutStatusModel.pipe(
            merge(this.checkoutService.changeEmitted$)
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            res => {
                // an end user has clicked the check out button and ready to check out       
                if (res != null) {
                    this.checkoutInitiated = res.hasChosenCheckout;
                    this.defaultFirstStep = res.firstStep;
                    this.currentCheckoutStep = res.currentStep;
                    this.checkoutMenuFilter = this.checkoutMenu;
                    this.tenantDetailsRequired = res.tenantDetailsRequired;

                    // NZ site is not using donation page for now
                    // if (!this.currentUserModel.isAU) {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'donationStep');
                    // }

                    if (res.collectOrder) {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'freightStep');
                    }
                    if (this.tenantDetailsRequired === 'NO' || !this.tenantDetailsRequired) {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'tenantStep');
                    }

                    if (this.defaultFirstStep === 'TENANT') {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'endUserStep' && item.id !== 'freightStep');
                    } else if (this.defaultFirstStep === 'ENDUSER') {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'freightStep');
                    } else if (this.defaultFirstStep === 'PAYMENT') {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'endUserStep' && item.id !== 'freightStep');
                    } else if (this.defaultFirstStep === 'NOENDUSER') {
                        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'endUserStep');
                    }
                    $('#levelOne').animate({ scrollLeft: 500 + $('#renewalDetails').width() }, 400);
                } else {
                    const urlCompArr = this.router.url.split("/",6);
                    this.router.navigate([urlCompArr.join("/")]);
                }
            }
        );

        this.route.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (params) => {
                this.serial = params.get('serial');
            }
        );

        this.router.events.pipe(filter(event => event instanceof NavigationEnd),takeUntil(this.ngUnsubscribe)).subscribe(res => {
            // this.breadcrumbRef.ngAfterViewInit();
            // this.isCheckOut = false;
            this.urlSegments = this.router.url.split('/');
            this.lastChild = this.urlSegments[this.urlSegments.length - 1];
            if (this.lastChild === 'ship-address') {
                this.currentCheckoutStep = 'ADDRESS';
                this.checkoutMenu.filter(i => i.id === 'addressStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'select-location') {
                this.currentCheckoutStep = 'ADDRESS';
                this.checkoutMenu.filter(i => i.id === 'addressStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'freight-ship') {
                this.currentCheckoutStep = 'FREIGHT';
                this.checkoutMenu.filter(i => i.id === 'freightStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'payment-method') {
                this.currentCheckoutStep = 'PAYMENT';
                this.checkoutMenu.filter(i => i.id === 'paymentStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'end-user' || this.lastChild === 'selectenduser') {
                this.currentCheckoutStep = 'ENDUSER';
                this.checkoutMenu.filter(i => i.id === 'endUserStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'summary-order') {
                this.currentCheckoutStep = 'SUMMARY';
                this.checkoutMenu.filter(i => i.id === 'summaryStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'tenant') {
                this.currentCheckoutStep = 'TENANT';
                this.checkoutMenu.filter(i => i.id === 'tenantStep')[0].selected = true;
                // this.isCheckOut = true;
            } else if (this.lastChild === 'order-confirmation') {
                // this.isCheckOut = true;
            } else if (this.lastChild === 'donation') {
                this.currentCheckoutStep = 'DONATION';
                this.checkoutMenu.filter(i => i.id === 'donationStep')[0].selected = true;
                // this.isCheckOut = true;
            }

        });
    }

    closeCheckoutPanel() {
        this.checkoutInitiated = false;
        this.router.navigate(['.'],{relativeTo:this.route.parent});
        //this.router.navigateByUrl(`/manageRenewalsNew/renewalDetails/${this.serial}`);
        $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
